import { analyzeConfigColorClient } from '../api';

export default class ConfigurationService {
  getRequestMethod(apiHasNoConfigs = false) {
    return apiHasNoConfigs
      ? this.createConfigData
      : this.updateConfigData;
  }

  fetchConfigData(idQuestionario, analyzeId, chartType) {
    const data = analyzeConfigColorClient.get(`/${idQuestionario}/question/${analyzeId}/chartType/${chartType}`);
    return data;
  }

  createConfigData(idQuestionario, analyzeId, newData, chartType) {
    const data = analyzeConfigColorClient.post(`/${idQuestionario}/question/${analyzeId}/chartType/${chartType}`, newData);
    return data;
  }

  updateConfigData(idQuestionario, analyzeId, newData, chartType) {
    const data = analyzeConfigColorClient.put(`/${idQuestionario}/question/${analyzeId}/chartType/${chartType}`, newData);
    return data;
  }
}
